import { retrieveItem } from "@src/helpers/functions";

export const useCheckLogin = () => {
  let isLoggedIn: boolean | null = null;
  const sessionId = retrieveItem("sessionId") ?? retrieveItem("sessionId");
  try {
    if (sessionId) {
      isLoggedIn = true;
    } else {
      isLoggedIn = false;
    }
  } catch (e) {
    isLoggedIn = false;
  }
  return isLoggedIn;
};